export const getStyles = () => {
    const styles = {
        clearImage: {
            position: 'absolute', 
            right: '45px',
            top: '1px', 
            backgroundColor: '#d3d3d3', 
            borderRadius: '50%', 
            '&:hover': { 
                backgroundColor: '#bfbfbf' 
            } 
        }
    };
    return styles;
};